import { defaultPorts } from '@doss/common-all'
import { appSdkAssetBaseFor } from '@doss/guest-frame/app-sdk'

// When loaded in a WebView (emulator or physical device), localhost refers to the
// device itself, not the host machine. Use the hostname from the current URL so
// service requests reach the dev server on the host machine.
const getLocalHost = () => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return window.location.hostname
  }
  return import.meta.env.VITE_LOCAL_HOST_IP || 'localhost'
}

export const config = {
  adminBaseUrl: `${getLocalHost()}:${defaultPorts.webAdmin}`,
  apiBaseUrl: `${getLocalHost()}:${defaultPorts.api}`,
  webBaseUrl: `${getLocalHost()}:${defaultPorts.web}`,
  webhooksBaseUrl: `${getLocalHost()}:${defaultPorts.webhooks}`,
  docuforgeBaseUrl: `${getLocalHost()}:${defaultPorts.docuforge}`,
  // ESM App SDK assets come from the staging CDN; VITE_APP_SDK_ASSET_BASE in .env.local points at a local SDK build
  appSdkAssetBase: import.meta.env.VITE_APP_SDK_ASSET_BASE || appSdkAssetBaseFor('staging'),
  sentryUrl:
    'https://819f3f17d2ab4a958e31abc91fdfa8b1@o4504896410025984.ingest.sentry.io/4505035079483392',
  logrocketId: 'l3k4df/doss-web',
  protocol: 'http',
  websocketProtocol: 'ws',
  jitsuHost: 'http://localhost:18001',
  jitsuWriteKey: 'R6vcWT9HnETyJYiPXi6qggupADnotSHi:laNVG9h3sEil81nkRYfpiUA6fSt3osUE',
  analyticsJitsuEnabled: false,
  perfTelemetryEnabled: false,
  stripePublishableKey:
    'pk_test_51LoEBoIr04lJNUdf2K625ZzB9nCgCsGHbqV16AnqzvpCXT63ggox6GgwetYTBHgUeJwFXY9zuQL3TdyCNHrhr51f00W38Np6C3',
  gcpServiceAccountEmail: '37653837791-compute@developer.gserviceaccount.com',
  stripeStagingPublishableKey:
    'pk_test_51LoEBoIr04lJNUdf2K625ZzB9nCgCsGHbqV16AnqzvpCXT63ggox6GgwetYTBHgUeJwFXY9zuQL3TdyCNHrhr51f00W38Np6C3',
  loopReturnsInstallUrl:
    'https://admin.loopreturns.com/third-party-integration/install/809ca80c-b15e-4977-bec1-991bb9cebd38',
}
